const overlayCls = "_61o2j5xnm";
const labelCls = "_61l1s9itxs";
const iconCls = "_61i78zuvf";

export { iconCls, labelCls, overlayCls };
import "./overlay.style.linaria.module.css";
//# sourceMappingURL=overlay.style.js.map
